export function setBrokenImageFallback(
  event: { currentTarget?: EventTarget | null; target?: EventTarget | null },
  fallbackSrc: string,
): void {
  const img = (event.currentTarget || event.target) as HTMLImageElement | null;
  if (!img) return;
  img.onerror = null;
  img.src = fallbackSrc;
}
